import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import RegisterForm from "@/components/auth/RegisterForm";
import type { SocialAuthResult } from "@/services/socialAuth";

export default function Register() {
  const navigate = useNavigate();
  const { register, registerError, isRegistering, socialLogin, isSocialLoggingIn, isAuthenticated } = useAuth();
  const [googleError, setGoogleError] = useState<Error | null>(null);

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/", { replace: true });
    }
  }, [isAuthenticated, navigate]);

  const handleSubmit = async (data: {
    email: string;
    password: string;
    first_name?: string;
    last_name?: string;
  }) => {
    await register(data);
    navigate("/pricing", { replace: true });
  };

  const handleGoogleSuccess = async (result: SocialAuthResult) => {
    try {
      setGoogleError(null);
      await socialLogin({
        provider: result.provider,
        id_token: result.idToken,
        email: result.email,
        name: result.name,
        first_name: result.firstName,
        last_name: result.lastName,
      });
      navigate("/pricing", { replace: true });
    } catch (error) {
      console.error("Google sign-up failed:", error);
      setGoogleError(error instanceof Error ? error : new Error("Google sign-up failed"));
    }
  };

  return (
    <div className="page-enter flex min-h-[calc(100vh-12rem)] items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="flex h-14 w-14 items-center justify-center rounded-xl bg-primary-600 text-white text-xl font-bold mx-auto">
            DT
          </div>
          <h1 className="mt-4 text-2xl font-bold text-gray-900">Create your account</h1>
          <p className="mt-1 text-sm text-gray-500">
            Start practising for your UK driving theory test
          </p>
        </div>

        <div className="rounded-xl border border-gray-200 bg-white p-8 shadow-sm">
          <RegisterForm
            onSubmit={handleSubmit}
            onGoogleSuccess={handleGoogleSuccess}
            error={registerError || googleError}
            isLoading={isRegistering}
            isGoogleLoading={isSocialLoggingIn}
          />
        </div>
      </div>
    </div>
  );
}
